import { GET_COUNSELLING_STUDENT_BY_ID } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_COUNSELLING_STUDENT_BY_ID:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAllCounsellingDetailByStudentId.js